import React, { useState, useEffect, useMemo } from 'react';
import {  useNavigate, useSearchParams } from "react-router-dom";
import CommonPopup from '../../components/common/CommonPopup';
import { playGameApi } from '../../services/authApi'
import { getPublicIp } from '../../services/pulicApi';
import { t, getLang, getGameTitle } from "../../lang";

export default function GamePage({ showLogin, isAuthenticated,}) {
  const navigate = useNavigate();

const [searchParams] = useSearchParams();

const gameCode = searchParams.get("gameCode");
const vendorCode = searchParams.get("vendorCode");
const gameData = useMemo(() => ({
  gameCode,
  vendorCode
}), [gameCode, vendorCode]);

  const [gameInfo, setGameInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [popup, setPopup] = useState(null);
  const [lang, setLangState] = useState(getLang());
  const token = localStorage.getItem('authToken');
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "authToken" && !event.newValue) {
        console.log("Logout detected");

        if (showLogin) {
          showLogin();
        }

        window.close(); // đóng cửa sổ game
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [showLogin]);

  useEffect(() => {
    const handler = () => setLangState(getLang());
    window.addEventListener("langChanged", handler);
    return () => window.removeEventListener("langChanged", handler);
  }, []);

  useEffect(() => {
    window.isGameOpen = true;

    fetchGameInfo();

    return () => {
      window.isGameOpen = false;
    };
  }, []);

  const fetchGameInfo = async () => {
    setIsLoading(true);
    try {

      const gameCode = gameData?.gameCode || '';
      const vendorCode = gameData?.vendorCode || '';

      const response = await playGameApi(gameCode, vendorCode);
      if (!response) return;

      const apiData = response.data?.data || response.data || {};

      const eventId = apiData.eventId || generateEventId();
      const clientIp = apiData.clientIp || await getClientIp();

      const currentTime = apiData.time || new Date().toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }) + ' PST';

      const gameUrl = apiData.url || apiData.gameUrl || `https://rt739qobgi.hvlhdbgi.biz/gs2c/playGame.do?`;
      const key = apiData.key || apiData.token || '';

      setGameInfo({
        url: gameUrl,
        key: key,
        eventId,
        clientIp,
        time: currentTime
      });
      console.log("Game info fetched successfully:", {
        url: gameUrl,
        key});
      return;
    } catch (error) {

      const eventId = generateEventId();
      const clientIp = await getClientIp();

      const currentTime = new Date().toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }) + ' PST';

      const gameUrl = `https://rt739qobgi.hvlhdbgi.biz/gs2c/playGame.do?`;

      const token = localStorage.getItem('authToken');
      const symbol = gameData?.gameCode || 'vs12bbb';

      const key = `token=${encodeURIComponent(token)}%60%7C%60symbol=${symbol}%60%7C%60language=ja%60%7C%60currency=EUR`;

      setGameInfo({
        url: gameUrl,
        key,
        eventId,
        clientIp,
        time: currentTime
      });

    } finally {
      setIsLoading(false);
    }
  };

  const generateEventId = () => {
    return Array.from({ length: 32 }, () =>
      Math.floor(Math.random() * 16).toString(16)
    ).join('');
  };

  const getClientIp = async () => {
    try {
      const response = await getPublicIp();
      return response.data.ip;
    } catch (error) {
      return '155.254.19.131';
    }
  };

  useEffect(() => {

    const depositHandler = () => {
      if (!window.isGameOpen) return;

      setPopup({
        title: "",
        message: "The deposit has been completed"
      });
    };

    const withdrawalHandler = () => {
      if (!window.isGameOpen) return;

      setPopup({
        title: "",
        message: "The withdrawal has been completed"
      });
    };

    const betLimitHandler = () => {
      if (!window.isGameOpen) return;

      setPopup({
        title: "",
        message: "ベット制限にかかっています。"
      });
    };

    const multipGameHandle = () => {
      if (!window.isGameOpen) return;

      setPopup({
        title: "",
        message: "Multiple simultaneous games are not allowed because your balance is insufficient."
      });
    };

    window.addEventListener("DepositCompleted", depositHandler);
    window.addEventListener("withdrawalCompleted", withdrawalHandler);
    window.addEventListener("BetLimitExceeded", betLimitHandler);
    window.addEventListener("Multiple_simultaneous_games", multipGameHandle);

    return () => {
      window.removeEventListener("DepositCompleted", depositHandler);
      window.removeEventListener("withdrawalCompleted", withdrawalHandler);
      window.removeEventListener("BetLimitExceeded", betLimitHandler);
      window.removeEventListener("Multiple_simultaneous_games", multipGameHandle);
    };

  }, []);

  const handleClosePopup = () => {
    setPopup(null);

    const iframe = document.getElementById("gameIframe");
    if (iframe) {
      iframe.src = iframe.src;
    }
  };

  const gameTitle = getGameTitle(gameData, lang) || gameData?.title || 'Game';

  return (
    <div className="game-page">
    
      <div className="game-page-content">

        {isLoading ? (
           <div className="load-more-loading">
              <div className="loading-spinner"></div>
              <span className="loading-text">{t("common.loading")}</span>
            </div>
        ) : (
          <>
            {gameInfo && (
              <iframe
                id="gameIframe"
                src={gameInfo.key ? `${gameInfo.url}${gameInfo.key}` : gameInfo.url}
                title={gameTitle}
                className="game-page-iframe"
                allowFullScreen
              />
            )}
          </>
        )}

      </div>

      {popup && (
        <CommonPopup
          title={popup.title}
          message={popup.message}
          onClose={handleClosePopup}
        />
      )}

    </div>
  );
}